<template>
    <div class="case">
        <div class="title">CASE</div>
        <div class="title">典型案例</div>
        <div class="case-items">
            <el-row>
                <el-col
                        v-for="(o, index) in cases"
                        :key="o"
                        :span="6"
                        :offset="index > 0 ? 2 : 1">
                    <div class="case-item">
                        <img :src="o.url" alt="" class="case-img">
                        <div class="case-title">{{ o.title }}</div>

                        <div style="flex: 1">
                            <div class="case-items-text">{{o.title}}</div>
                            <div class="case-items-text">{{o.context}}</div>


                        </div>
                        <div class="btn">
                            MORE
                        </div>
                    </div>

                </el-col>
            </el-row>

        </div>
    </div>
</template>

<script>
export default {
  name: "Case",
  data() {
    return {
      cases: [
        {
          url: require("@/assets/images/v2_s3sjjx.jpg"),
          title: '长沙市大气智能防控系统',
          context: '面向移动端GIS应用场景，提供满足二三维一体化的数据采集、管理、可视化表达、编辑。'
        },{
          url: require("@/assets/images/v2_s3sjmc.jpg"),
          title: '鹤壁市大气智能防控系统',
          context: '旨在实时检测和分析空气质量数据的高级环境监测和响应平台，利用先进的遥感技术和人工智能算法模型预测污染趋势，为政府和公众提供准确的污染报告及应对建议。'
        },{
          url: require("@/assets/images/v2_s3sj9t.jpg"),
          title: '京津冀大气智能防控系统',
          context: '面向移动端GIS应用场景，提供全面的二三维一体化数据服务，包括高效的空气质量数据采集、精确的数据管理、直观的三维可视化表达以及灵活的数据编辑功能。'
        }
      ],
    };

  },
  methods: {
    handleClick(index) {
      if (index === 0) {
        console.log('s');
      }
    }
  }
}
</script>

<style lang="less" scoped>
.case {
  padding: 40px 0;
  background-image: url("@/assets/images/v2_s3sjwb.jpg");
  height: 780px;
  color: white;
}
.title {
  text-align: left;
  margin-bottom: 10px;
  margin-left: 120px;
  font-size: 50px;
}
.case-items {
  padding: 20px 100px;
}
.case-item {
  background-color: rgba(82, 162, 238, 0.48);
  width: 100%;
  height: 590px;
  padding: 20px;
  position: relative;
  display: flex;
  flex-direction: column;
  .case-img {
    width: 100%;
    height: 300px;
  }
  .case-title {
    position: absolute;
    background-color: rgba(7, 18, 40, 0.28);
    width: calc(100% - 40px);
    height: 80px;
    top: 130px;
    line-height: 80px;
    font-size: 30px;
  }
  .case-items-text {
    text-align: left;
    font-size: 25px;
    margin-top: 30px;
  }
  .btn {
    color: white;

    font-size: 25px;
    cursor: pointer;
  }
}
</style>